import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  message: ''
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    getBanners: (state) => {
      state.loading = true;
    },
    successBanners: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedBanners: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  getBanners, 
  successBanners, 
  failedBanners 
} = bannerSlice.actions;

export default bannerSlice.reducer;
